import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import TicketCard from "./TicketCard";
import moment from "moment-jalaali";
import DatePicker from "react-datepicker2";
import "moment/locale/fa";

export default function TicketsPage() {
  const navigate = useNavigate();
  const ticketsPerPage = 1;

  const [showLogo, setShowLogo] = useState(true);
  const [showPrice, setshowPrice] = useState(true);
  const [showTerminal, setShowTerminal] = useState(true);
  const [totalPrice, setTotalPrice] = useState(2000000);

  const [airline, setAirline] = useState("کاسپین");
  const [flightNumber, setFlightNumber] = useState("CP123");
  const [numTickets, setNumTickets] = useState(5);
  const [fromCity, setFromCity] = useState("تهران");
  const [toCity, setToCity] = useState("مشهد");
  const [ticketState, setTicketState] = useState([]);
  const [fromTerminal, setFromTerminal] = useState("ترمینال ۱");

  // تاریخ‌ها به صورت moment
  const [issueDate, setIssueDate] = useState(moment());
  const [departureDate, setDepartureDate] = useState(moment().add(1, "days"));

  // ساعت پرواز 24 ساعته
  const [departureTime, setDepartureTime] = useState(moment().format("HH:mm"));

  // همگام‌سازی لیست مسافرها با تعداد بلیط
  useEffect(() => {
    setTicketState(prev =>
      Array.from({ length: numTickets }, (_, i) => prev[i] ?? {
        id: i + 1,
        passenger: `مسافر ${i + 1}`,
        passengerType: "بزرگسال",
        cabinClass: "اکونومی",
      })
    );
  }, [numTickets]);

  const updateTicket = (id, changes) => {
    setTicketState(prev =>
      prev.map(t => (t.id === id ? { ...t, ...changes } : t))
    );
  };

  // اطلاعات پایه بلیط
  const baseTicket = useMemo(() => ({
    ticketNumber: "0002447978702",
    issueDate: issueDate.format("jYYYY/jMM/jDD"),
    pnr: "SMUU3",
    fromCity,
    fromAirport: "فرودگاه مهرآباد",
    fromTerminal,
    toCity,
    toAirport: "فرودگاه بوشهر",
    toTerminal: "—",
    departureTime,
    departureDate: departureDate.format("jYYYY/jMM/jDD"),
    arrivalTime: moment(departureTime, "HH:mm").add(1, "hours").format("HH:mm"),
    baggage: "20 KG",
  }), [fromCity, toCity, fromTerminal, issueDate, departureDate, departureTime]);

  // گروه‌بندی بلیط‌ها برای چاپ
  const groupedTickets = useMemo(() => {
    const result = [];
    for (let i = 0; i < ticketState.length; i += ticketsPerPage) {
      result.push(ticketState.slice(i, i + ticketsPerPage));
    }
    return result;
  }, [ticketState, ticketsPerPage]);

  // خروج از سیستم
  const handleLogout = () => {
    localStorage.removeItem("loginData");
    navigate("/login", { replace: true });
  };

  return (
    <div className="container-fluid my-4" dir="rtl">
      <div className="row">
        {/* پنل تنظیمات */}
        <div className="col-md-4 col-lg-3 no-print">
          <h4 className="text-center">صدور بلیط هواپیما</h4>
          <button onClick={handleLogout} className="btn btn-danger w-100 my-2">خروج</button>

          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="mb-3 text-center">اطلاعات پرواز</h6>

              {/* نمایش لوگو */}
              <div className="form-check mb-2" style={{ paddingRight: "25px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="showLogo"
                  checked={showLogo}
                  onChange={e => setShowLogo(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="showLogo">
                  نمایش لوگو روی بلیط
                </label>
              </div>

           {/* نمایش قیمت */}
              <div className="form-check mb-2" style={{ paddingRight: "25px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="showLogo"
                  checked={showPrice}
                  onChange={e => setshowPrice(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="showPrice">
                  نمایش قیمت روی بلیط
                </label>
              </div>








              {/* نمایش ترمینال خروجی */}
<div className="form-check mb-2" style={{ paddingRight: "25px" }}>
  <input
    className="form-check-input"
    type="checkbox"
    id="showTerminal"
    checked={showTerminal}
    onChange={e => setShowTerminal(e.target.checked)}
  />
  <label className="form-check-label" htmlFor="showTerminal">
    نمایش ترمینال خروجی روی بلیط
  </label>
</div>

              {/* مجموع قیمت */}
              <div className="mb-2">
                <label>مجموع قیمت:</label>
                <input
                  type="text"
                  className="form-control"
                  value={totalPrice.toLocaleString("en-US")}
                  onChange={e => {
                    const raw = e.target.value.replace(/,/g, "");
                    if (!isNaN(raw)) {
                      setTotalPrice(Number(raw));
                    }
                  }}
                />
              </div>

              {/* ایرلاین */}
              <div className="mb-2">
                <label>ایرلاین:</label>
                <input
                  type="text"
                  className="form-control"
                  value={airline}
                  onChange={e => setAirline(e.target.value)}
                />
              </div>

              {/* شماره پرواز */}
              <div className="mb-2">
                <label>شماره پرواز:</label>
                <input
                  type="text"
                  className="form-control"
                  value={flightNumber}
                  onChange={e => setFlightNumber(e.target.value)}
                />
              </div>

              {/* مبدا و مقصد */}
              <div className="mb-2">
                <label>مبدا:</label>
                <input className="form-control" value={fromCity} onChange={e => setFromCity(e.target.value)} />
              </div>
              <div className="mb-2">
                <label>مقصد:</label>
                <input className="form-control" value={toCity} onChange={e => setToCity(e.target.value)} />
              </div>

              {/* ترمینال خروجی */}
              <div className="mb-2">
                <label>ترمینال خروجی:</label>
                <select className="form-select" value={fromTerminal} onChange={e => setFromTerminal(e.target.value)}>
                  <option value="ترمینال ۱">ترمینال ۱</option>
                  <option value="ترمینال ۲">ترمینال ۲</option>
                  <option value="ترمینال ۴">ترمینال ۴</option>
                  <option value="ترمینال سلام">ترمینال سلام</option>
                </select>
              </div>

              {/* تاریخ‌ها با DatePicker */}
              <div className="mb-2">
                <label>تاریخ صدور بلیط:</label>
                <DatePicker
                  isGregorian={false}
                  value={issueDate}
                  onChange={value => setIssueDate(value)}
                  inputClass="form-control"
                />
              </div>
              <div className="mb-2">
                <label>تاریخ پرواز:</label>
                <DatePicker
                  isGregorian={false}
                  value={departureDate}
                  onChange={value => setDepartureDate(value)}
                  inputClass="form-control"
                />
              </div>

              {/* ساعت پرواز */}
              <div className="mb-2">
                <label>ساعت پرواز:</label>
                <input
                  type="time"
                  className="form-control"
                  value={departureTime}
                  onChange={e => setDepartureTime(e.target.value)}
                />
              </div>

              {/* تعداد بلیط */}
              <div className="mb-3">
                <label>تعداد بلیط:</label>
                <input
                  type="number"
                  min={1}
                  max={50}
                  className="form-control"
                  value={numTickets}
                  onChange={e => setNumTickets(Math.max(1, Number(e.target.value)))}
                />
              </div>

              <hr />

              {/* مسافرها */}
              <h6>مسافرها:</h6>
              <div style={{ maxHeight: "45vh", overflowY: "auto" }}>
                {ticketState.map(t => (
                  <div key={t.id} className="mb-3">
                    <input
                      className="form-control mb-1"
                      value={t.passenger}
                      onChange={e => updateTicket(t.id, { passenger: e.target.value })}
                    />
                    <select
                      className="form-select mb-1"
                      value={t.passengerType}
                      onChange={e => updateTicket(t.id, { passengerType: e.target.value })}
                    >
                      <option value="نوزاد">نوزاد</option>
                      <option value="کودک">کودک</option>
                      <option value="بزرگسال">بزرگسال</option>
                    </select>
                    <select
                      className="form-select"
                      value={t.cabinClass}
                      onChange={e => updateTicket(t.id, { cabinClass: e.target.value })}
                    >
                      <option value="اکونومی">اکونومی</option>
                      <option value="بیزینس">بیزینس</option>
                      <option value="فرست کلاس">فرست کلاس</option>
                    </select>
                  </div>
                ))}
              </div>

              <button onClick={() => window.print()} className="btn btn-primary w-100 mt-3">
                🖨️ پرینت بلیط‌ها
              </button>
            </div>
          </div>
        </div>

        {/* نمایش بلیط‌ها */}
        <div className="col-md-8 col-lg-9 ticket-scroll" style={{ maxHeight: "80vh", overflowY: "auto", paddingRight: 10 }}>
          {groupedTickets.map((group, idx) => (
            <div key={idx} className="print-page mb-4">
              <div className="row">
                {group.map(t => (
                  <div key={t.id} className="col-md-7 mb-3">
                    <TicketCard
                      ticket={{
                        ...baseTicket,
                        passenger: t.passenger,
                        passengerType: t.passengerType,
                        cabinClass: t.cabinClass,
                        totalPrice,
                        airline,
                        flightNumber,
                      }}
                      showLogo={showLogo}
                      showTerminal={showTerminal}
                      showPrice={showPrice}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
